import { useContext, useCallback, memo } from 'react';
import { useIntl } from 'react-intl';
import GlobalNavContext from '../../../../context/GlobalNavContext.js';
import TrapdoorDescriptionColumn from '../../TrapdoorDescriptionColumn.js';
import TrapdoorProductListColumn from '../../TrapdoorProductListColumn.js';
import AccessibilityWrapper from '../AccessibilityWrapper.js';
import { PRODUCT_LIST_UK, PRODUCT_LIST } from './constants.js';
import messages from './messages.js';
import { jsxs, jsx } from 'react/jsx-runtime';
function TrapdoorContentDevelopers({
  linkRefs,
  contentRefs
}) {
  const _useIntl = useIntl(),
    formatMessage = _useIntl.formatMessage;
  const _useContext = useContext(GlobalNavContext),
    isUKUser = _useContext.isUKUser;
  const developersLinks = isUKUser ? PRODUCT_LIST_UK : PRODUCT_LIST;
  const setRef = useCallback(el => contentRefs['developers'] = el, [contentRefs]);
  return /*#__PURE__*/jsxs(AccessibilityWrapper, {
    id: "global-nav-dropdown-developers",
    children: [/*#__PURE__*/jsx(TrapdoorProductListColumn, {
      columnData: developersLinks,
      messages: messages,
      linkRefs: linkRefs,
      columnKey: "developers"
    }), /*#__PURE__*/jsx(TrapdoorDescriptionColumn, {
      ref: setRef,
      title: formatMessage(messages.developersTitle),
      description: formatMessage(messages.developersDescription),
      linkText: formatMessage(messages.developersLinkText),
      url: "https://onchainkit.xyz/",
      image: "https://static-assets.coinbase.com/growth/acquisition/global-nav/upsell/developers_upsell.png"
    }, "global-nav-dropdown-developers-description")]
  });
}
const DevelopersContent = /*#__PURE__*/memo(TrapdoorContentDevelopers);
export { DevelopersContent as default };
//# sourceMappingURL=Developers.js.map
